<template>
  <v-card flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-card :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-row class="no-gutters mt-4 mb-2">
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card-actions class="py-5 d-flex justify-space-between">
            <div class="d-flex align-center">
              <v-icon color="#647E98" class="mr-2">mdi mdi-home-alert-outline</v-icon>
              <span class="text--green">Residence Verification</span>
            </div>

            <v-dialog v-if="$canRoute('documents-reg-tab') === 1" transition="scale-transition" origin="center center" max-width="985px"
              v-model="uploadNewDoc" content-class="deposit-modal">
              <template v-slot:activator="{ on, attrs }">
                <div class="d-flex align-items-center">
                  <div v-bind="attrs" v-on="on">
                    <div class="d-flex align-center download-icon">
                      <span>Upload Proof</span>
                      <v-icon class="ml-1">mdi-upload</v-icon>
                    </div>
                  </div>
                </div>
              </template>

              <template>
                <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" class="deposit-form">
                  <v-btn class="close-btn" icon dark @click="uploadNewDoc = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-card-title>
                    <div class="image-details">
                      <v-icon color="#647E98" class="mr-2">mdi mdi-account-outline</v-icon>
                      <h3>Residence Proof</h3>
                    </div>
                    <div class="content-details">
                      <span style="color:#04A982">New</span>
                    </div>
                  </v-card-title>
                  <v-card-text v-if="selectedNewFile">
                    <div class="preview-wrapper">
                      <template v-if="isPDF(selectedNewFile)">
                        <iframe :src="selectedNewFile" width="100%" height="400px" title="iframe"></iframe>
                      </template>
                      <template v-else-if="selectedNewFile">
                        <img :src="selectedNewFile" class="preview-image" alt="Preview" />
                      </template>
                    </div>
                  </v-card-text>
                  <v-card-subtitle>
                    <div class="download-icon">
                      <div class="file-upload">
                        <input type="file" ref="fileInput" @change="(event) => handleNewFileUpload(event)"
                          accept=".jpg,.jpeg,.png,.webp,.pdf" style="display: none" />
                        <div @click="triggerFileInput" class="download-icon">
                          <p>Upload Proof</p>
                          <v-icon>mdi-upload</v-icon>
                        </div>
                      </div>
                    </div>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <h1>Residence Information</h1>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Name</legend>
                          <v-text-field v-model="personalinfo.fullname" disabled single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Country</legend>
                          <v-text-field :value="personalinfo.countries?.name || ''" readonly single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <div class="button-wrapper">
                          <v-btn
                              :disabled="isLoading || $canRoute('documents-reg-tab') !== 1"
                              small
                              tile
                              elevation="0"
                              block
                              class="ma-0 text-capitalize btn-account py-4"
                              color="greenMain"
                              @click="uploadReadyNewFile"
                              :loading="isLoading"
                            >
                              Save & Approved
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="button-wrapper">
                          <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                            color="#FF567F" @click="uploadNewDoc = false; selectedNewFile = null">
                            Cancel
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </v-dialog>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table hide-default-footer :headers="headers" :items-per-page="5" :items="userDocuments.residence">
      <template v-slot:item.document_url="{ item }">
        <div>
          <p v-if="!item.document_url">No File</p>
          <img v-else-if="isImage(item.document_url)" :src="item.document_url" alt="trx" width="50px" />
          <img v-else :src="pdfIcon" alt="trx" width="50px" />
        </div>
      </template>

      <template v-slot:item.updated_at="{ item }">
        {{ formatMySQLDate(item?.updated_at) }}
      </template>

      <template v-slot:item.comment="{ item }">
        <span class="d-inline-block text-truncate" style="max-width: 150px;">{{ item.comment || "N/A" }}</span>
      </template>

      <template v-slot:item.action_by="{ item }">
        {{ item.action_by || "N/A" }}
      </template>

      <template v-slot:item.status="{ item }">
        <div class="d-flex align-items-center justify-center">
          <div>
            <v-icon small :class="verifyIcon(item.status)"></v-icon>
            {{ item.status }}
          </div>
          <div v-if="item.status === 'Pending'" v-bind="attrs" v-on="on" :class="verifyModal(item.status)">
            <v-dialog transition="scale-transition" origin="center center" max-width="985px"
              v-model="uploadModal[item.id]" content-class="deposit-modal">
              <template v-slot:activator="{ on, attrs }">
                <div class="d-flex align-items-center">
                  <div v-bind="attrs" v-on="on">
                    <v-btn v-if="$canRoute('documents-reg-tab') === 1" x-small icon tile style="background: #039de91a">
                      <v-icon x-small color="#039de9">mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>

              <template>
                <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" class="deposit-form">
                  <v-btn class="close-btn" icon dark @click="closeUploadModal(item)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-card-title>
                    <div class="image-details">
                      <v-icon color="#647E98" class="mr-2">mdi mdi-account-outline</v-icon>
                      <h3>Identity Proof</h3>
                    </div>
                    <div class="content-details">
                      <span :color="item.status === 'Pending' ? '#647E98' : ''">{{ item.status }}</span>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <iframe v-if="item.document_url" :src="item.document_url" width="100%" height="400px"
                      title="iframe"></iframe>
                    <iframe v-else src="" width="100%" height="400px" title="iframe"></iframe>
                  </v-card-text>
                  <v-card-subtitle>
                    <a :href="item.document_url" download target="_blank" rel="noopener noreferrer"
                      class="download-icon">
                      <p class="text--green">Download</p>
                      <v-icon>mdi-download</v-icon>
                    </a>
                    <a :href="item.document_url" target="_blank" rel="noopener noreferrer" class="tab-details">
                      <p class="text--green">Open In New Tab</p>
                      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2033_47716)">
                          <path
                            d="M1.12305 9.99967C1.12305 9.99967 4.45638 3.33301 10.2897 3.33301C16.123 3.33301 19.4564 9.99967 19.4564 9.99967C19.4564 9.99967 16.123 16.6663 10.2897 16.6663C4.45638 16.6663 1.12305 9.99967 1.12305 9.99967Z"
                            stroke="#039de9" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M10.2891 12.5C11.6698 12.5 12.7891 11.3807 12.7891 10C12.7891 8.61929 11.6698 7.5 10.2891 7.5C8.90835 7.5 7.78906 8.61929 7.78906 10C7.78906 11.3807 8.90835 12.5 10.2891 12.5Z"
                            stroke="#039de9" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_2033_47716">
                            <rect width="20" height="20" fill="white" transform="translate(0.289062)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                    <div v-if="item.status !== 'Approved'" class="download-icon">
                      <div class="file-upload" v-if="$canRoute('documents-reg-tab') === 1">
                        <input type="file" ref="fileInput" @change="(event) => handleFileUpload(item, event)"
                          accept=".jpg,.jpeg,.png,.webp,.pdf" style="display: none" />
                        <div @click="triggerFileInput" class="download-icon">
                          <p>Re-upload</p>
                          <v-icon>mdi-upload</v-icon>
                        </div>
                      </div>
                    </div>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <h1>Identity Information</h1>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Name</legend>
                          <v-text-field v-model="item.clientName" disabled single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Country</legend>
                          <v-text-field v-model="item.clientCountry" disabled single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Uploaded Date</legend>
                          <v-text-field v-model="item.updated_at" disabled single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Status</legend>
                          <v-text-field v-model="item.status" disabled single-line solo hide-details
                            class="custom-select">
                            <v-icon small slot="prepend" color="#FFC020">
                              mdi-star-outline
                            </v-icon></v-text-field>
                        </fieldset>
                      </v-col>
                    </v-row>
                    <div>
                      <v-row v-if="item.status === 'Pending'">
                        <v-col cols="6">
                          <div class="button-wrapper">
                            <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                              color="greenMain" :disabled="$canRoute('documents-reg-tab') !== 1" @click="approveDoc(item)">
                              Save & Approved
                            </v-btn>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="button-wrapper">
                            <v-btn small tile elevation="0" :disabled="$canRoute('documents-reg-tab') !== 1" block class="ma-0 text-capitalize btn-account py-4"
                              color="#FF567F" @click="showRejectionCauseSection = true">
                              Rejected
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row v-else-if="item.status === 'Approved'">
                        <v-col cols="12">
                          <div class="button-wrapper">
                            <v-btn disabled small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                              color="greenMain">
                              Approved
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row v-else="item.status === 'Rejected'">
                        <v-col cols="12">
                          <div class="button-wrapper">
                            <v-btn disabled small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                              color="greenMain">
                              Rejected
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row v-if="item.status === 'Pending' && showRejectionCauseSection">
                        <v-col cols="12">
                          <h2>Rejection Cause</h2>
                        </v-col>
                        <v-col cols="12">
                          <fieldset>
                            <legend>Reason</legend>
                            <v-select v-model="cancel_reason" solo :items="reasons" append-icon="mdi-chevron-down"
                              label="Click to select" class="custom-select" hide-details></v-select>
                          </fieldset>
                        </v-col>
                        <v-col cols="12" v-if="cancel_reason === 'Custom'">
                          <fieldset>
                            <legend>Write Your Reason</legend>
                            <v-text-field v-model="comment" single-line label="Write Here" solo hide-details
                              class="custom-select"></v-text-field>
                          </fieldset>
                        </v-col>
                        <v-col cols="6">
                          <div class="button-wrapper">
                            <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                              color="#FF567F" @click="rejectDoc(item)">
                              Confirm Reject
                            </v-btn>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="button-wrapper">
                            <v-btn small tile elevation="0" block outlined class="ma-0 text-capitalize btn-account py-4"
                              @click="showRejectionCauseSection = false">
                              Cancel
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </template>
            </v-dialog>
          </div>
        </div>
      </template>
      <!-- DONE VIEW -->
      <template v-slot:item.view="{ item }">
        <v-dialog transition="scale-transition" origin="center center" max-width="985px" v-model="uploadModal[item.id]"
          content-class="deposit-modal">
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex align-items-center">
              <div v-bind="attrs" v-on="on">
                <v-icon color="#039de9" small>
                  mdi-eye-outline
                </v-icon>
              </div>
            </div>
          </template>

          <template>
            <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" class="deposit-form">
              <v-btn class="close-btn" icon dark @click="closeUploadModal(item)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-card-title>
                <div class="image-details">
                  <v-icon color="#647E98" class="mr-2">mdi mdi-account-outline</v-icon>
                  <h3>Identity Proof</h3>
                </div>
                <div class="content-details">
                  <span :color="item.status === 'Pending' ? '#647E98' : ''">{{ item.status }}</span>
                </div>
              </v-card-title>
              <v-card-text class="text-center">
                <iframe v-if="isPDF(item.document_url)" :src="item.document_url" width="100%" height="400px" title="iframe"></iframe>
                <img v-else :src="item.document_url" class="text-center" width="auto" height="400px" alt="">
              </v-card-text>
              <v-card-subtitle>
                <a :href="item.document_url" download target="_blank" rel="noopener noreferrer" class="download-icon">
                  <p class="text--green">Download</p>
                  <v-icon>mdi-download</v-icon>
                </a>
                <a :href="item.document_url" target="_blank" rel="noopener noreferrer" class="tab-details">
                  <p class="text--green">Open In New Tab</p>
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2033_47716)">
                      <path
                        d="M1.12305 9.99967C1.12305 9.99967 4.45638 3.33301 10.2897 3.33301C16.123 3.33301 19.4564 9.99967 19.4564 9.99967C19.4564 9.99967 16.123 16.6663 10.2897 16.6663C4.45638 16.6663 1.12305 9.99967 1.12305 9.99967Z"
                        stroke="#039de9" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M10.2891 12.5C11.6698 12.5 12.7891 11.3807 12.7891 10C12.7891 8.61929 11.6698 7.5 10.2891 7.5C8.90835 7.5 7.78906 8.61929 7.78906 10C7.78906 11.3807 8.90835 12.5 10.2891 12.5Z"
                        stroke="#039de9" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2033_47716">
                        <rect width="20" height="20" fill="white" transform="translate(0.289062)" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <div v-if="item.status !== 'Approved'" class="download-icon">
                  <div class="file-upload" v-if="$canRoute('documents-reg-tab') === 1">
                    <input type="file" ref="fileInput" @change="(event) => handleFileUpload(item, event)"
                      accept=".jpg,.jpeg,.png,.webp,.pdf" style="display: none" />
                    <div @click="triggerFileInput" class="download-icon">
                      <p>Re-upload</p>
                      <v-icon>mdi-upload</v-icon>
                    </div>
                  </div>
                </div>
              </v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <h1>Identity Information</h1>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Name</legend>
                      <v-text-field v-model="item.clientName" disabled single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Country</legend>
                      <v-text-field v-model="item.clientCountry" disabled single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>

                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Uploaded Date</legend>
                      <v-text-field v-model="item.updated_at" disabled single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <fieldset>
                      <legend>Status</legend>
                      <v-text-field v-model="item.status" disabled single-line solo hide-details class="custom-select">
                        <v-icon small slot="prepend" color="#FFC020">
                          mdi-star-outline
                        </v-icon></v-text-field>
                    </fieldset>
                  </v-col>
                </v-row>
                <div>
                  <v-row v-if="item.status === 'Pending'">
                    <v-col cols="6">
                      <div class="button-wrapper">
                        <v-btn small tile elevation="0" :disabled="$canRoute('documents-reg-tab') !== 1" block class="ma-0 text-capitalize btn-account py-4"
                          color="greenMain" @click="approveDoc(item)">
                          Save & Approved
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="button-wrapper">
                        <v-btn small tile elevation="0" :disabled="$canRoute('documents-reg-tab') !== 1" block class="ma-0 text-capitalize btn-account py-4"
                          color="#FF567F" @click="showRejectionCauseSection = true">
                          Rejected
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-else-if="item.status === 'Approved'">
                    <v-col cols="12">
                      <div class="button-wrapper">
                        <v-btn disabled small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                          color="greenMain">
                          Approved
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-else="item.status === 'Rejected'">
                    <v-col cols="12">
                      <div class="button-wrapper">
                        <v-btn disabled small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                          color="greenMain">
                          Rejected
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="item.status === 'Pending' && showRejectionCauseSection">
                    <v-col cols="12">
                      <h2>Rejection Cause</h2>
                    </v-col>
                    <v-col cols="12">
                      <fieldset>
                        <legend>Reason</legend>
                        <v-select v-model="cancel_reason" solo :items="reasons" append-icon="mdi-chevron-down"
                          label="Click to select" class="custom-select" hide-details></v-select>
                      </fieldset>
                    </v-col>
                    <v-col cols="12" v-if="cancel_reason === 'Custom'">
                      <fieldset>
                        <legend>Write Your Reason</legend>
                        <v-text-field v-model="comment" single-line label="Write Here" solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="6">
                      <div class="button-wrapper">
                        <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                          color="#FF567F" @click="rejectDoc(item)">
                          Confirm Reject
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="button-wrapper">
                        <v-btn small tile elevation="0" block outlined class="ma-0 text-capitalize btn-account py-4"
                          @click="showRejectionCauseSection = false">
                          Cancel
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </template>
        </v-dialog>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import toast from "@/services/Notification";
import { CLIENTS_DOCUMENTS__ACTIONS, PROFILE__ACTIONS, REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import AssignManagerTable from "./AssignManagerTable.vue";

export default {
  data() {
    return {
      isLoading: false,
      newSelectedFileFormData: null,
      selectedNewFile: null,
      clientId: null,
      modal: false,
      dialog: false,
      uploadNewDoc: false,
      uploadModal: {},
      imageIcon: require('@/assets/profile.png'),
      pdfIcon: require('@/assets/pdf.png'),
      headers: [
        { text: "Date and Time", align: "start", value: "updated_at" },
        { text: "Comment", value: "comment" },
        { text: "Proof", value: "document_url" },
        { text: "Action By", value: "action_by" },
      ],
      cancel_reason: null,
      reasons: ["Wrong Document", "Document is not clear", "Custom"],
      comment: "",
      showRejectionCauseSection: false,
    };
  },
  components: {
    AssignManagerTable,
  },
  computed: {
    ...mapState("reguserdetails", ["userDocuments", "personalinfo"]),
    ...mapState("profile", ["client"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    isPDF(url) {
      return url?.toLowerCase().endsWith('.pdf');
    },
    //formatMySQLDate is needed for timeformat
    formatMySQLDate,
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS, REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO]),
    ...mapActions("profile", [
      PROFILE__ACTIONS.GETPROFILE,
      PROFILE__ACTIONS.UPLOADDOCUMENT,
    ]),
    ...mapActions("clientsDocuments", [
      CLIENTS_DOCUMENTS__ACTIONS.VERIFYDOC
    ]),

    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    verifyIcon(status) {
      if (status === "Approved") return "mdi mdi-check text--green mr-1";
      else if (status === "Rejected")
        return "mdi mdi-window-close red--text mr-1";
      else return "mdi mdi-refresh mr-1 yellow--text";
    },
    verifyModal(status) {
      if (status === "Approved") return "d-none ml-0";
      else if (status === "Rejected") return "d-block ml-2";
      else return "d-block ml-2";
    },
    isImage(url) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', "webp"];
      const extension = url.split('.').pop().toLowerCase();
      return imageExtensions.includes(extension);
    },
    closeUploadModal(item) {
      this.$set(this.uploadModal, item?.id, false);
    },

    async handleFileUpload(item, event) {
      try {
        const file = event.target.files[0];

        if (!file) {
          throw new Error('Please select a file to upload!');
        }

        if (file.size > 4 * 1024 * 1024) {
          throw new Error('File size should be less than 4MB');
        }

        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/webp', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
          throw new Error('Invalid file format. Upload JPG, JPEG, PNG, WEBP, PDF only.');
        }

        const formData = new FormData();
        formData.append('rFile', file);
        formData.append('client_account_id', this.clientId);

        if (item) {
          formData.append('document_id', item.id);
        }

        await this[PROFILE__ACTIONS.UPLOADDOCUMENT](formData);

        await Promise.all([
          this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](this.clientId),
          this[PROFILE__ACTIONS.GETPROFILE](this.clientId),
        ]);

      } catch (error) {
        toast.error(error.message || "Invalid file or file size")
      } finally {
        event.target.value = '';
      }
    },

    async handleNewFileUpload(event) {
      try {
        const file = event.target.files[0];

        if (!file) {
          throw new Error('Please select a file to upload!');
        }

        if (file.size > 4 * 1024 * 1024) {
          throw new Error('File size should be less than 4MB');
        }

        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image.webp', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
          throw new Error('Invalid file format. Upload JPG, JPEG, PNG, WEBP, PDF only.');
        }

        this.selectedNewFile = URL.createObjectURL(file);

        const formData = new FormData();
        formData.append('rFile', file);
        formData.append('client_account_id', this.clientId);

        this.newSelectedFileFormData = formData

      } catch (error) {
        toast.error(error.message || "Invalid file or file size")
      } finally {
        event.target.value = '';
      }
    },

    async uploadReadyNewFile() {
      try {
        this.isLoading = true
        await this[PROFILE__ACTIONS.UPLOADDOCUMENT](this.newSelectedFileFormData);

        await Promise.all([
          this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](this.clientId),
          this[PROFILE__ACTIONS.GETPROFILE](this.clientId),
        ]);
        this.uploadNewDoc = false;
        this.newSelectedFileFormData = null
        this.selectedNewFile = null

      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    async approveDoc(item) {
      let parameter = {
        id: item?.id,
        status: 1
      }
      this[CLIENTS_DOCUMENTS__ACTIONS.VERIFYDOC](parameter);
      await Promise.all([
        this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](this.clientId),
        this[PROFILE__ACTIONS.GETPROFILE](this.clientId),
        this[REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO](this.clientId),
      ]);
      this.closeUploadModal(item)
    },

    async rejectDoc(item) {
      let parameter = {
        id: item?.id,
        status: 0,
        comment: this.comment,
        cancel_reason: this.cancel_reason,
      }
      this[CLIENTS_DOCUMENTS__ACTIONS.VERIFYDOC](parameter);
      await Promise.all([
        this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](this.clientId),
        this[PROFILE__ACTIONS.GETPROFILE](item.client_account_id),
        this[REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO](this.clientId),
      ]);
      this.closeUploadModal(item)
    },
  },
  async mounted() {
    this.clientId = this.$route.params.id
    this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](this.$route.params.id);
    this[REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO](this.$route.params.id);
    if (this.$canRoute('documents-reg-tab') > 0) {
      this.headers.push({ text: "Status & Actions", value: "status" });
      this.headers.push({ text: "View", value: "view" });
    }
  },
};
</script>

<style scoped>
.preview-wrapper {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.preview-image {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>